import '../styles/dashboard-master.css';

function buildActiveFilters(filterFields, filterValues) {
  if (!filterFields || !filterValues) return [];
  return filterFields
    .filter((f) => {
      const val = filterValues[f.key];
      if (Array.isArray(val)) return val.length > 0;
      return val !== undefined && val !== null && val !== '';
    })
    .map((f) => {
      const val = filterValues[f.key];
      // multiselect（配列）の場合
      if (Array.isArray(val)) {
        if (f.options) {
          const labels = val.map((v) => {
            const opt = f.options.find((o) => String(o.value ?? o) === String(v));
            return opt ? (opt.label ?? opt) : v;
          });
          return { label: f.label, value: labels.join(', ') };
        }
        return { label: f.label, value: val.join(', ') };
      }
      // select の場合は options から表示ラベルを取得
      if (f.type === 'select' && f.options) {
        const opt = f.options.find((o) => String(o.value) === String(val));
        return { label: f.label, value: opt ? opt.label : val };
      }
      return { label: f.label, value: val };
    });
}

export default function ExportConfirmPopup({
  open,
  onClose,
  onExport,
  filteredCount,
  totalCount,
  loading,
  sheetName = '',
  filterFields = null,
  filterValues = null,
}) {
  if (!open) return null;

  const activeFilters = buildActiveFilters(filterFields, filterValues);
  const hasFilters = activeFilters.length > 0;

  return (
    <div className="db-entry-popup-overlay" onClick={onClose} role="presentation">
      <div
        className="db-entry-popup"
        style={{ width: 'min(480px, 90vw)', maxHeight: 'none' }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="エクスポート確認"
      >
        <div className="db-entry-popup-header">
          <h3>エクスポート{sheetName ? ` - ${sheetName}` : ''}</h3>
        </div>
        <div style={{ padding: '20px 18px' }}>
          {hasFilters && (
            <div style={{
              marginBottom: '16px',
              padding: '12px',
              background: '#f8fafc',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
            }}>
              <p style={{
                margin: '0 0 8px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#64748b',
                letterSpacing: '0.05em',
              }}>
                適用中のフィルタ
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                {activeFilters.map((f) => (
                  <div key={f.label} style={{ display: 'flex', fontSize: '13px', gap: '8px' }}>
                    <span style={{ color: '#64748b', minWidth: '100px', flexShrink: 0 }}>{f.label}:</span>
                    <span style={{ color: '#1e293b', fontWeight: 500 }}>{f.value}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!hasFilters && (
            <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#94a3b8' }}>
              フィルタは適用されていません
            </p>
          )}
          <p style={{ margin: '0 0 12px', fontSize: '14px', color: '#374151' }}>
            エクスポートするデータの範囲を選択してください。
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <button
              className="master-primary-button"
              style={{ width: '100%', height: '42px', fontSize: '14px' }}
              onClick={() => onExport('filtered')}
              disabled={loading || filteredCount === 0}
              type="button"
            >
              {loading ? '出力中...' : `表示中のデータ（${filteredCount}件）`}
            </button>
            <button
              className="master-secondary-button"
              style={{ width: '100%', height: '42px', fontSize: '14px' }}
              onClick={() => onExport('all')}
              disabled={loading || totalCount === 0}
              type="button"
            >
              {loading ? '出力中...' : `全データ（${totalCount}件）`}
            </button>
          </div>
        </div>
        <div className="tpl-select-footer">
          <button className="master-secondary-button" onClick={onClose} disabled={loading} type="button">
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
}
